import { reactive, ref } from 'vue'

import { ReactivityUtil } from '@shared/utils/Reactivity'

const isActive = ref(false)
const isFailed = ref(false)
const options = reactive({})

function preventKeydown(event) {
  event.preventDefault()
  event.stopPropagation()
}

function endInputPreventer() {
  document.body.style.setProperty('pointer-events', 'initial')
  document.removeEventListener('keydown', preventKeydown)
}

class Loading {
  start(opts = {}) {
    isActive.value = true
    isFailed.value = false

    if (opts === false) opts = {}

    document.body.style.setProperty('pointer-events', 'none')
    document.addEventListener('keydown', preventKeydown)

    opts.blocking = opts.blocking ?? true
    ReactivityUtil.reAssign(options, opts)
  }

  end() {
    isActive.value = false
    isFailed.value = false

    endInputPreventer()
  }

  failed() {
    isFailed.value = true
    isActive.value = false

    endInputPreventer()
  }

  getState() {
    return {
      active: isActive.value,
      failed: isFailed.value,
      options: options,
    }
  }
}

export default new Loading()
